import React from 'react';
import {Redirect} from 'react-router-dom';
import {connect} from 'react-redux';
import {Grid, Header, Segment, Button} from 'semantic-ui-react';
import {connectDynamic} from 'go/components/dynamic/dynamicComponent';
import _ from 'lodash';
import {shouldDisplay} from 'componentLibrary/layout/ShowHide';
import {StatusIndicator} from 'app-ui-componentlibrary';
import {forceJsonResponse, MONO, FLUX} from 'common/utils';
import {Alert} from 'componentLibrary';
import REST from 'go/requests/rest';
import {
  STATUS_PENDING_AOR_SIGNATURE,
  STATUS_PENDING_SAR_SIGNATURE,
  STATUS_PENDING_SUBMISSION,
  STATUS_SUBMITTED_TO_FEMA,
} from 'app-ui-componentlibrary/dist/common/constants';
import {evalSectionStatus, shouldDisplaySection} from 'common/utils';
import produce from 'immer';
import {getTimestampNowISO} from 'common/utils';
import CollaborationActions from 'go/actions/api/collaboration';

export class DynamicReview extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      redirect: false,
      sectionTitleLocations: [],
      allValidationErrors: {},
    };
  }

  componentDidMount() {
    this.updateSectionData();
  }

  componentDidUpdate(prevProps, prevState) {
    if (!_.isEqual(prevProps.allValidationErrors, this.props.allValidationErrors)) {
      this.updateSectionData();
    }
  }

  updateSectionData() {
    const {configSections, allValidationErrors} = this.props;
    let sections = [];
    let sectionTitleLocations = [];
    let sectionHierarchyIndexes = [];

    const createSectionData = (section, index) => {
      sections.push({
        id: section.id,
        sectionName: _.trim(section.title),
        status: evalSectionStatus(section, allValidationErrors),
        isHidden: !shouldDisplaySection(section, this.props, shouldDisplay),
      });

      if (section.navToChildren) {
        sectionHierarchyIndexes.push(index);
        let children =
          section.type === 'ShowHide' ? section.renderAs.contents : section.contents;
        _.forEach(children, (subSection, index) => {
          createSectionData(subSection, index);
        });
        sectionHierarchyIndexes.pop();
      } else {
        sectionTitleLocations.push({
          hierarchyIndexes: [...sectionHierarchyIndexes, index],
          title: section.title,
        });
      }
    };

    _.map(configSections, (section, index) => createSectionData(section, index));
    this.setState({sections});
    this.setState({sectionTitleLocations});
  }

  handleSubmit = (password) => {
    const {
      data,
      config,
      userId,
      entityType,
      entityId,
      status,
      token,
      entitiesToLockUnlock,
      grantId,
      toggles,
      fundingOpportunityName,
      startWorkflow,
      collaborativeSubmission,
      context,
    } = this.props;
    let lockActionRequest = '',
      paramsToPass;
    if (_.includes(toggles, 'lockActionWithEntity') || _.isEmpty(grantId)) {
      lockActionRequest = 'Entities';
      paramsToPass = entitiesToLockUnlock;
    } else {
      paramsToPass = grantId;
    }

    const statusPendingSignature =
      status === STATUS_PENDING_AOR_SIGNATURE || status === STATUS_PENDING_SAR_SIGNATURE;

    const lockAction = statusPendingSignature
      ? `unlock${lockActionRequest}`
      : `lock${lockActionRequest}`;
    const successRedirectTo = statusPendingSignature ? `edit` : `view`;
    const isToggled = _.includes(toggles, 'checkApplicationVersion');
    const isCollaborationEnabled =
      _.get(
        context,
        'fundingOpportunityData.configData.collaborationEnabled.applicationEdit',
        false
      ) === true;
    REST.dynamicData
      .getEntityById(token, entityId)
      .then((res) => forceJsonResponse(res, MONO))
      .then((data) => {
        //check if application has been previously submitted to fema when the current status at the time of submission
        //by the end user is pendingSubmission or pendingAorSignature
        if (
          (isToggled &&
            !isCollaborationEnabled &&
            entityType === 'application' &&
            status === STATUS_PENDING_SUBMISSION &&
            (_.get(data, 'status') === STATUS_PENDING_AOR_SIGNATURE ||
              _.get(data, 'status') === STATUS_SUBMITTED_TO_FEMA)) ||
          (status === STATUS_PENDING_AOR_SIGNATURE &&
            _.get(data, 'status') === STATUS_SUBMITTED_TO_FEMA)
        ) {
          this.setState({
            isError: true,
            errorMsg: 'This application has already been submitted by another user.',
          });
          return true;
        } else {
          REST.dynamicData[lockAction](token, paramsToPass)
            .then(REST.handler.handleResponse)
            .then((resJson) => {
              if (startWorkflow) {
                REST.dynamicData
                  .getEntityById(token, entityId)
                  .then((res) => res.json())
                  .then((resJson) => {
                    const updatedData = produce(resJson, (draft) => {
                      _.set(draft, 'payload.submittedBy', token.userId);
                      _.set(draft, 'payload.submittedTimestamp', getTimestampNowISO());
                    });
                    return updatedData;
                  })
                  .then((newData) => {
                    return REST.dynamicData.updateEntity(token, newData);
                  })
                  .then((res) => {
                    // Start workflow if status === 200
                    if (res.status === 200) {
                      const topLevelParams = {
                        organizationId: data.organizationId,
                        subOrgId: data.subOrganizationId,
                        fundingOpportunityId: data.fundingOpportunityId,
                        programId: data.programId,
                      };

                      const startingProcessVariables = {
                        entityId: data.entityId,
                        entityType: entityType,
                        submittedUserId: userId,
                        submittedTimestamp: getTimestampNowISO(),
                        entityNumber: data.entityNumber,
                        organizationId: data.organizationId,
                        organizationName: data.payload.orgDisplayName,
                        subOrgId: data.subOrganizationId,
                        subOrganizationName: data.payload.subOrgDisplayName,
                        fundingOpportunityName,
                        ...topLevelParams,
                      };

                      this.setState({submitting: true});

                      let snapshotData = produce(data, (draft) => {
                        _.set(draft, 'id', data.entityId);
                      });
                      REST.snapshot
                        .postSnapshot(token, snapshotData)
                        .then(REST.handler.handleResponse)
                        .then((res) => {
                          return REST.workflow.startProcess(
                            token,
                            config.processToStart,
                            password,
                            topLevelParams,
                            startingProcessVariables
                          );
                        })
                        .catch((err) => {
                          console.error('error');
                          this.setState({
                            error: true,
                          });
                          return err;
                        });
                      // Navigate after workflow starts
                      this.setState({
                        redirect: true,
                        redirectTo: successRedirectTo,
                        entityId: entityId,
                      });
                    }
                  })
                  .catch((error) => {
                    console.error('error');
                    this.setState({isError: true});
                  });
              } else {
                // Navigate after action
                if (resJson) {
                  collaborativeSubmission && collaborativeSubmission(resJson, entityId);
                  this.setState({
                    redirect: true,
                    redirectTo: successRedirectTo,
                    entityId: entityId,
                  });
                }
              }
            })
            .catch((error) => {
              console.error('error');
              this.setState({isError: true});
            });
        }
      });
  };

  goToLocation = (sectionName) => {
    this.props.saveEntitySessionData('validationErrors.submissionAttempted', true);

    let locationArray = _.filter(this.state.sectionTitleLocations, (x) => {
      return sectionName === x.title;
    });

    let location = '';
    _.forEach(_.get(locationArray[0], 'hierarchyIndexes'), (value, index) => {
      if (index > 0) {
        location += '.';
      }
      location += 'contents[' + value + ']';
    });

    this.props.navToSpecificLocation(location);
  };

  renderSection = (status, name, recursiveDepth) => {
    return (
      <Grid.Row key={name}>
        {recursiveDepth > 0 && <Grid.Column width={recursiveDepth} />}
        <Grid.Column width={1}>
          <StatusIndicator status={status} name={name} />
        </Grid.Column>
        <Grid.Column width={7}>{name}</Grid.Column>
        <Grid.Column
          textAlign="center"
          floated="right"
          width={2}
          title={`Navigate to ${name}`}
        >
          {this.props.sectionedPages ? (
            <a
              onClick={() => this.goToLocation(name)}
              href={'#' + name}
              title={`Navigate to ${name}`}
            >
              View/edit
            </a>
          ) : (
            <a
              onClick={() =>
                this.props.saveEntitySessionData(
                  'validationErrors.submissionAttempted',
                  true
                )
              }
              href={'#' + name}
              title={`Navigate to ${name}`}
            >
              View/edit
            </a>
          )}
        </Grid.Column>
      </Grid.Row>
    );
  };

  renderSections = (sections, recursiveDepth) => {
    const stateSections = this.state.sections;

    let sectionsAggragateStatus = 'complete';
    let renderCodeArray = _.map(sections, (section) => {
      let sectionName = _.trim(this.props.sectionedPages ? section.name : section);
      let matchedSectionsArray = _.filter(stateSections, ['sectionName', sectionName]);
      if (_.size(matchedSectionsArray) < 1 || _.get(matchedSectionsArray, '0.isHidden')) {
        return '';
      }

      let subSectionsToCheck = _.get(section, 'subSectionsToCheck', undefined);
      if (subSectionsToCheck !== undefined) {
        let retData = this.renderSections(subSectionsToCheck, recursiveDepth + 1);

        let sectionHeaderRenderCode = (
          <Grid.Row>
            {recursiveDepth > 0 && <Grid.Column width={recursiveDepth} />}
            <Grid.Column width={1}>
              <StatusIndicator status={retData.status} name={sectionName} />
            </Grid.Column>
            <Grid.Column width={7}>{sectionName}</Grid.Column>
          </Grid.Row>
        );

        if (retData.status === 'needsAttention') {
          sectionsAggragateStatus = 'needsAttention';
        }

        retData.renderCode.unshift(sectionHeaderRenderCode);
        return retData.renderCode;
      } else {
        if (_.get(matchedSectionsArray, '0.status') === 'needsAttention') {
          sectionsAggragateStatus = 'needsAttention';
        }
        return this.renderSection(
          _.get(matchedSectionsArray, '0.status'),
          sectionName,
          recursiveDepth
        );
      }
    });

    let retData = {
      status: sectionsAggragateStatus,
      renderCode: renderCodeArray,
    };

    return retData;
  };

  render() {
    const {id, submitButtonLabel, sectionedPages, grantId, entityType} = this.props;
    const {redirect, redirectTo, entityId, sections, isError, errorMsg} = this.state;

    var isComplete = sections === undefined ? false : true;
    _.forEach(sections, (section) => {
      if (!section.isHidden && section.status === 'needsAttention') isComplete = false;
    });

    return (
      <React.Fragment>
        {redirect ? (
          <Redirect push to={`/${entityType}/${entityId}/${redirectTo}`} />
        ) : (
          <div id={id} className="margin-top--standard">
            {isError ? (
              <Alert
                size="tiny"
                header="Error"
                content={errorMsg != undefined ? errorMsg : 'Could not submit'}
                type="error"
                dismissable={false}
              />
            ) : (
              ''
            )}
            <Grid>
              <Grid.Row>
                {_.size(sections) > 0 && (
                  <Grid.Column width="10">
                    {this.props.title && <Header as="h2">{this.props.title}</Header>}
                  </Grid.Column>
                )}
                <Grid.Column
                  width="6"
                  textAlign={_.size(sections) > 0 ? 'right' : 'left'}
                >
                  {submitButtonLabel && (
                    <Button
                      color={'blue'}
                      id={'submitReview'}
                      value={'value'}
                      type={'type'}
                      onClick={this.handleSubmit}
                      disabled={!isComplete}
                      width={'medium'}
                    >
                      {submitButtonLabel}
                    </Button>
                  )}
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column colSpan={'2'}>
                  {this.props.guidance && <p>{this.props.guidance}</p>}
                </Grid.Column>
              </Grid.Row>
            </Grid>
            {isComplete && _.size(sections) > 0 && _.isEmpty(errorMsg) ? (
              <Alert
                size="tiny"
                header={this.props.alertHeader}
                content={this.props.alertContent}
                type="success"
                dismissable={false}
              />
            ) : (
              ''
            )}
            <div className="contents">
              <Grid divided="vertically">
                {this.state.sections !== undefined &&
                  this.renderSections(this.props.sectionsToCheck, 0).renderCode}
                <Grid.Row />
              </Grid>
            </div>
          </div>
        )}
      </React.Fragment>
    );
  }
}
export const mapStateToProps = (state, componentProps) => {
  let props = {
    token: state.auth.token,
    toggles: state.toggles.toggles,
  };

  if (componentProps.navDependencies) {
    _.forEach(componentProps.navDependencies, (dep) => {
      props[dep.name] = _.get(state.dynamicComponent, dep.path);
    });
  }
  return props;
};

export const mapDispatchToProps = (dispatch) => ({
  collaborativeSubmission: (result, entityId) => {
    const entityList = _.filter(_.flatten([result]), (e) => e.entityId === entityId);
    const [entity = {}] = entityList;
    const {modifiedBy: who, grantId, subGrantId, entityType} = entity;
    dispatch(
      CollaborationActions.submission({who, grantId, subGrantId, entityId, entityType})
    );
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(connectDynamic(DynamicReview));
